module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Qacuta/Tokyo_Qacuta_HadGEM2_RCP85_Now.png";